export const LOGIN_START = 'login/login-start';
export const LOGIN_SUCCESS = 'login/login-success';
export const LOGIN_CHANGED_LANGAUGE = 'login/login-changed-language';
